export const getDateOnlyFromString = (dateString: string): string => {
  try {
    return new Date(dateString).toISOString().split('T')[0]
  } catch (error) {
    return ''
  }
}
